import Modal from 'components/Modal'
import IcashTopupTx from 'views/MemberProfile/ManualTx/IcashTopupTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalIcashTopupTx = ({ title, open, onClose }: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <IcashTopupTx onClose={onClose} />
    </Modal>
  )
}

export default ModalIcashTopupTx
